export const GET_DATASOURCES="app/list/GET_DATASOURCES";
export const GET_DATASOURCE="app/edit/GET_DATASOURCE";
export const POST_DATASOURCE="app/edit/POST_DATASOURCE";
export const GET_TAGS="app/list/GET_TAGS";
